import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from './firebase';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import HomeSlidesManager from './components/HomeSlidesManager';
import PhotoSlidesManager from './components/PhotoSlidesManager';
import WomenInitiativesManager from './components/WomenInitiativesManager';
import AwarenessImagesManager from './components/AwarenessImagesManager';
import AwarenessVideosManager from './components/AwarenessVideosManager';
import CampaignsManager from './components/CampaignsManager';
import SchemesManager from './components/SchemesManager';
import InspirationalWomenManager from './components/InspirationalWomenManager';
import FeedbackManager from './components/FeedbackManager';
import UsersManager from './components/UsersManager';
import NotificationsManager from './components/NotificationsManager';
import './App.css';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  if (loading) {
    return (
      <div className="loading-container">
        <div className="spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }

  return (
    <Router>
      <div className="App">
        <Routes>
          <Route
            path="/login"
            element={user ? <Navigate to="/dashboard" /> : <Login />}
          />
          <Route
            path="/dashboard"
            element={user ? <Dashboard /> : <Navigate to="/login" />}
          />
          <Route
            path="/home-slides"
            element={user ? <HomeSlidesManager /> : <Navigate to="/login" />}
          />
          <Route
            path="/photo-slides"
            element={user ? <PhotoSlidesManager /> : <Navigate to="/login" />}
          />
          <Route
            path="/women-initiatives"
            element={user ? <WomenInitiativesManager /> : <Navigate to="/login" />}
          />
          <Route
            path="/awareness-images"
            element={user ? <AwarenessImagesManager /> : <Navigate to="/login" />}
          />
          <Route
            path="/awareness-videos"
            element={user ? <AwarenessVideosManager /> : <Navigate to="/login" />}
          />
          <Route
            path="/campaigns"
            element={user ? <CampaignsManager /> : <Navigate to="/login" />}
          />
          <Route
            path="/schemes"
            element={user ? <SchemesManager /> : <Navigate to="/login" />}
          />
          <Route
            path="/inspirational-women"
            element={user ? <InspirationalWomenManager /> : <Navigate to="/login" />}
          />
          <Route
            path="/feedbacks"
            element={user ? <FeedbackManager /> : <Navigate to="/login" />}
          />
          <Route
            path="/users"
            element={user ? <UsersManager /> : <Navigate to="/login" />}
          />
          <Route
            path="/notifications"
            element={user ? <NotificationsManager /> : <Navigate to="/login" />}
          />
          <Route
            path="/"
            element={<Navigate to={user ? "/dashboard" : "/login"} />}
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
